import { render, staticRenderFns } from "./PeiTransitionStudentSAEE12Document.vue?vue&type=template&id=0fa5dca6&scoped=true"
import script from "./PeiTransitionStudentSAEE12Document.vue?vue&type=script&lang=js"
export * from "./PeiTransitionStudentSAEE12Document.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5dca6",
  null
  
)

export default component.exports